import type { Model, GlobalAction } from './types';
import { getCookie } from 'globals/cookieManager';

export const initialState: Model = {
  isComingFromNative: !!getCookie('isComingFromNative'),
  isCompanyInitialised: false,
  isKeyboardActive: false,
};

export function globalReducer(
  state: Model = initialState,
  action: GlobalAction,
): Model {
  switch (action.type) {
    case 'GLOBAL/IS_COMPANY_INITIALISED':
      return {
        ...state,
        isCompanyInitialised: action.isCompanyInitialised,
      };
    case 'GLOBAL/SET_KEYBOARD_ACTIVE':
      return {
        ...state,
        isKeyboardActive: action.isKeyboardActive,
      };
    default:
      return state;
  }
}
